/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IDocumentoDetalleCompuesto from 'Infotrack@Modelos/smartStock/documentosDetalle/entidades/documentoDetalleCompuesto';
import { AnyAction } from 'redux';

export interface IEstadoAlmacenamiento {
    bodegaId?: number;
    cargarTablaDocumentoDetalle: boolean;
    documentoId?: string;
    documentoDetalle?: IDocumentoDetalleCompuesto;
    estadoFormularioDetalle: boolean;
    estadoFormularioEdicion: boolean;
    tipoDocumentoId?: number;
    recargarTabla: boolean;
}

export const estadoInicial: IEstadoAlmacenamiento = {
    bodegaId: undefined,
    cargarTablaDocumentoDetalle: true,
    documentoId: undefined,
    documentoDetalle: undefined,
    estadoFormularioDetalle: false,
    estadoFormularioEdicion: false,
    tipoDocumentoId: undefined,
    recargarTabla: false,
};

export enum acciones {
    CARGAR_DOCUMENTO_DETALLE = 'CARGAR_DOCUMENTO_DETALLE',
    CAMBIAR_ESTADO_FORMULARIO_DETALLE = 'CAMBIAR_ESTADO_FORMULARIO_DETALLE',
    CAMBIAR_ESTADO_FORMULARIO_EDICION = 'CAMBIAR_ESTADO_FORMULARIO_EDICION',
    ESTABLECER_BODEGA = 'ESTABLECER_BODEGA',
    ESTABLECER_TIPO_DOCUMENTO = 'ESTABLECER_TIPO_DOCUMENTO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}

export const reductor = (estado: IEstadoAlmacenamiento = estadoInicial, { type, payload }: AnyAction) => {
    switch (type) {
        case acciones.CARGAR_DOCUMENTO_DETALLE: {
            return {
                ...estado,
                cargarTablaDocumentoDetalle: !estado.cargarTablaDocumentoDetalle,
            };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_DETALLE: {
            return {
                ...estado,
                estadoFormularioDetalle: !estado.estadoFormularioDetalle,
                documentoId: payload ? payload : undefined,
            };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_EDICION: {
            return {
                ...estado,
                estadoFormularioEdicion: !estado.estadoFormularioEdicion,
                documentoDetalle: payload ? payload : undefined,
            };
        }

        case acciones.ESTABLECER_BODEGA: {
            return { ...estado, bodegaId: payload };
        }

        case acciones.ESTABLECER_TIPO_DOCUMENTO: {
            return { ...estado, tipoDocumentoId: payload };
        }

        case acciones.RECARGAR_TABLA: {
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };
        }

        default:
            return estado;
    }
};
